import { render, staticRenderFns } from "./gynecologyReport.vue?vue&type=template&id=422720a4&scoped=true"
import script from "./gynecologyReport.vue?vue&type=script&lang=js"
export * from "./gynecologyReport.vue?vue&type=script&lang=js"
import style0 from "./gynecologyReport.vue?vue&type=style&index=0&id=422720a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422720a4",
  null
  
)

export default component.exports